import {Pipe, PipeTransform} from '@angular/core';
import {ValidationInfoInput, toFormControlValidator} from './draft-validator';

@Pipe({
  name: 'toValidator',
  standalone: false
})
export class ValidatorPipe implements PipeTransform {
  // NOC-2396: ValidationInfoInput forces a `variant` at this boundary whenever
  // the config carries a customValidation closure (see draft-validator.ts).
  transform<ValidationInfo extends { validations?: unknown }>(
    validationInfo: ValidationInfoInput<ValidationInfo>,
    options?: any
  ) {
    if (validationInfo?.validations) {
      return toFormControlValidator<ValidationInfo>(
        validationInfo,
        options
      );
    }
    return null;
  }
}
